import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxEnumSelect', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" class="form-control-static cx-enum-select" editable-select="value" onbeforesave="save({newValue:$data})" onaftersave="afterSave({})" e-ng-options="item.key as (item.label || item.value) for item in items" edit-disabled="disabled" e-placeholder="{{placeholder}}">' +
        '<span ng-show="value || value===0">{{displayFunc({value:value}) || (value | translateList:type:labels[value])}}</span>' +
        '<i ng-show="!value && value!==0 && !showPlaceholderIfNull && !displayValueIfNull" class="glyphicon glyphicon-pencil" ></i>' +
        '<span ng-show="!value && value!==0 && showPlaceholderIfNull===true">{{placeholder}}</span>' +
        '<span ng-show="!value && value!==0 && !showPlaceholderIfNull && displayValueIfNull">{{displayValueIfNull}}</span>' +
        '</a>',
      scope: {
        value: '=data',
        type: '@',
        save: '&',
        afterSave: '&',
        displayFunc: '&?',
        disabled: '=?',
        placeholder: '=?',
        showPlaceholderIfNull: '=?',
        displayValueIfNull: '=?',
        orderByLabel: '@?',
        allowNull: '=?',
        hideItems: '=?',
      },
      controller: [
        '$scope',
        'enumCacheSvc',
        'translateListFilter',
        '$filter',
        function($scope, enumCacheSvc, translateListFilter, $filter) {
          $scope.items = [];
          $scope.labels = {};

          this.$onInit = function() {
            enumCacheSvc.get($scope.type).then(function(data) {
              $scope.items = ($scope.hideItems && $scope.hideItems.length > 0
                ? data.filter(x => !$scope.hideItems.includes(x.key))
                : data
              ).map(item => ({
                ...item,
                label: $scope.displayFunc
                  ? $scope.displayFunc({ value: item.key })
                  : translateListFilter(item.key, $scope.type, item.value),
              }));

              $scope.items = $filter('orderBy')($scope.items, $scope.orderByLabel ? 'label' : 'key');
              if ($scope.allowNull) {
                $scope.items = [{ key: null, value: '', label: '' }, ...$scope.items];
              }

              $scope.labels = data.reduce(function(o, e) {
                o[e.key] = e.value;
                return o;
              }, {});
            });
          };
        },
      ],
    };
  },
]);
